<template>
	<div class="hourly-input">
		<label class="hour-label">{{ hourLabel }}</label>
		<input
			type="number"
			:value="formData[fieldName]"
			@input="handleInput"
			min="0"
			step="1"
			class="hour-input"
		>
	</div>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'HourlyInput',

	props: {
		hour: {
			type: Number,
			required: true,
		},
	},

	data: () => ({
		formData,
	}),

	computed: {
		fieldName () {
			return `customLoad_${String(this.hour).padStart(2, '0')}`
		},

		hourLabel () {
			const hour12 = this.hour % 12 || 12
			const suffix = this.hour < 12 ? 'AM' : 'PM'
			return `${hour12} ${suffix}`
		},
	},

	methods: {
		handleInput ({ target: { value } }) {
			formData[this.fieldName] = parseInt(value) || 0
		},
	},
}
</script>

<style scoped>
.hourly-input {
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 10px;
}

.hour-label {
	font-size: 0.75rem;
	font-weight: 600;
	margin-bottom: 4px;
	white-space: nowrap;
}

.hour-input {
	width: 80px;
	padding: 1px 6px;
	text-align: center;
	border: 1px solid #ccc;
	border-radius: 1px;
}

.hour-input:focus {
	border-color: #28a745;
	outline: none;
}
</style>
